import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router.jsx';
import { queryClient } from './lib/queryClient.js';
import { installSessionGuard } from './lib/sessionGuard.js';
import { applyBrand } from './lib/brand.js';
import '@fontsource-variable/plus-jakarta-sans';
import './styles/index.css';

// The client this instance is for (lib/brand.js): its colours, type, title and icon, before the first paint.
applyBrand();

// Before any request can go out: one wrapper that turns a 401 from our backend into an honest
// "your session has ended", instead of each screen reporting a dead session as its own failure.
installSessionGuard();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" /> : null}
    </QueryClientProvider>
  </StrictMode>,
);
